module.exports = __webpack_public_path__ + "src/img/shen.d7d641d6.png";